@import 'styles/mixins';
@import 'styles/variables';

.root {
  display: flex;
  background-color: var(--neutral-5);
  border-radius: 6px;
  align-items: center;
  padding: 0;
  position: relative;
}

.highlighter {
  background: var(--neutral-0);
  position: absolute;
  height: 32px;
  left: 0;
  border-radius: 4px;
  @include secondary-button-shadow;
  transition-property: width, transform, background-color;
  transition-timing-function: ease-in-out;
  transition-duration: 125ms;
}

.item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  flex-shrink: 0;
  height: 32px;
  z-index: 1;
  @include btn-sm-text;
  color: var(--neutral-50);
  transition: color ease-in-out 125ms;
  margin: 0;
  padding: 0 16px;
  @include line-clamp;

  &:hover {
    color: var(--neutral-50);
  }
}

.slimButton {
  padding: 0 6px;
}

.mediumButton {
  padding: 0 10px;
}

.flexButton {
  flex-basis: max-content;
}

.icon {
  flex-shrink: 0;
  transition: fill ease-in-out 125ms;

  &.withText {
    margin-right: 4px;
  }
}

.inactiveIconColor {
  color: var(--neutral-30);

  path {
    fill: var(--neutral-30);
  }
}

.activeIconColor {
  color: var(--neutral-90);

  path {
    fill: var(--neutral-90);
  }
}

.itemActive {
  color: var(--neutral-90);

  &:hover {
    color: var(--neutral-90);
  }
}
